var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('div',[_c('img',{attrs:{"src":require("@/assets/check_confirm.svg")}})]):_c('div',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }